import { register, find } from '../../../../Javascript/Sysmex/Utils'
import Cookies from 'js-cookie'

const ProfessionalityConsent = el => {
  const prefix = el.dataset.prefix
  find('button[name=professionalAccept]', el).addEventListener('click', accept)
  find('button[name=professionalDenie]', el).addEventListener('click', denie)

  checkCookie()

  function checkCookie () {
    if (!Cookies.get('professionalConsent')) {
      el.style.display = 'block'
    }
  }

  function setCookie () {
    Cookies.set('professionalConsent', 'true', { expires: 1 })
    el.style.display = 'none'
  }

  function accept () {
    setCookie()
  }

  function denie () {
    el.classList.add(prefix + 'is--denied')
  }
}

register('ProfessionalityConsent', ProfessionalityConsent)
